<template>
  <v-container class="py-10 py-md-13 py-lg-16">
    <TitleWidget>Política de Privacidade</TitleWidget>

    <PolicyPrivacyWidget class="primary--text text--lighten-1 mt-4 mt-md-6" />
  </v-container>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import PolicyPrivacyWidget from "../components/widgets/PolicyPrivacyWidget.vue";

export default {
  components: {
    TitleWidget,
    PolicyPrivacyWidget,
  },
};
</script>

<style></style>
